import { EbizioEvent, EbizioEventConfig, EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const giftCertificatesChangedHandler = ({ detail }: EbizioEvent) => {
  logger('Gift Certificates Changed');
  console.log(detail);
};

export const giftCertificatesChangedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.GIFT_CERTIFICATES_CHANGED,
  handler: giftCertificatesChangedHandler,
};
